import { REACT_APP_CLOUD_FRONT } from "../../../constants";

export const filters = [
  {
    id: "filter_4",
    logo: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/Veg-icon.svg`,
    name: "Vegetarian",
    selected: false,
  },
  {
    id: "filter_3",
    logo: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/Keto-icon.svg`,
    name: "keto",
    selected: false,
  },
  {
    id: "filter_2",
    logo: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/Low-cal-icon.svg`,
    name: "Low Calories",
    selected: false,
  },
  {
    id: "filter_1",
    logo: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/High-pro-icon.svg`,
    name: "High Protein",
    selected: false,
  },
  {
    id: "filter_5",
    logo: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/Dairy-free-icon.svg`,
    name: "Dairy-Free Option",
    selected: false,
  },
];
